<template>
<div class="addZz">
  <div class="topkkk">
    <div>
      <p>请选择单位</p>
      <el-select v-model="shop" filterable class="xza" @change="ss" size="small" placeholder="请选择">
        <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <p style="padding-left: 50px;">预约时间</p>
      <el-date-picker
          class="xza"
          size="small"
          v-model="time"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
      </el-date-picker>
    </div>
    <el-button type="primary"  size="small" @click="ss">搜索</el-button>
  </div>

  <div class="sjz">
    <ul >
      <li :class="idx == rqidx ? 'xzls' : ''" v-for="(item, idx) in timeList" @click="tebsj(idx)">{{item}}</li>
    </ul>
  </div>


  <div class="content-nr">
    <div class="ysxx" v-for="item in doctorList" @click="hqyspb(item.ExpertId)">
      <img :src="'http://zsjstaticfile.oss-cn-shenzhen.aliyuncs.com/'+item.ExpertstrImgUrl" alt="">
      <h4>{{item.ExpertName}}</h4>
      <p class="zy">{{item.ExpertWorkTitle}}</p>
      <p class="dw">{{item.ExpertCompany}}</p>
    </div>
    <div v-if="!doctorList.length" style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;font-size: 20px;">
      暂无排班
    </div>
  </div>

  <el-dialog
      title="排班列表"
      :visible.sync="dialogVisible"
      width="50%"
  >
    <ul class="phsj">
      <li v-for="item in jzList">
        <p>{{item.ScheduleStartTime}} - {{item.ScheduleEndTime}}</p>
        <p>排号费：{{item.ScheduleCost}}元</p>
        <p>号源数：{{item.ScheduleReservations - item.ScheduleReservationCount}}</p>
        <el-button type="primary" @click="yy(item)">预约</el-button>
      </li>
    </ul>
  </el-dialog>
</div>
</template>

<script>
import {getShoop, getScheduleDoctorList, getDoctorScheduleList, insertOppointment} from "./api"
import pf from "@/publicFn/baseFn"
export default {
  name: "addZz",
  data() {
    return {
      options: [],
      time: '',
      shop: '',
      jzList: [],
      doctorList: [],
      dialogVisible: false,
      exid: '',
      timeList: [],
      rqidx: 0
    }
  },
  created() {
    let arrs = []
    for (let i = 0; i < 30; i++) {
      arrs.push(pf.getTime(i))
    }
    this.timeList = [...arrs]

    let ling = this.$loading({
      background: 'rgba(0, 0, 0, 0.7)',
      text: '加载中...'
    })
    getShoop()
    .then(res => {
      ling.close()
      let arr = []
      if (res.Result.CompanyInfos && res.Result.CompanyInfos.length) {
        let obj = res.Result.CompanyInfos
        for (let i = 0; i < obj.length; i++) {
          if (obj[i].CompanyInfos) {
              for (let  k = 0; k < obj[i].CompanyInfos.length; k++) {
                for (let h = 0; h < obj[i].CompanyInfos[k].ShopInfos.length; h++) {
                  arr.push(obj[i].CompanyInfos[k].ShopInfos[h])
                }
              }
          }else {
            if (obj[i].ShopInfos.length) {
              for (let p = 0; p < obj[i].ShopInfos.length; p++) {
                arr.push(obj[i].ShopInfos[p])
              }
            }
          }
        }
      }
      if (arr.length) {
        let abb = []
        for (let i = 0; i < arr.length; i++) {
          abb.push({
            value: arr[i].ShopId,
            label: arr[i].ShopName
          })
        }
        this.shop = abb[0].value
        this.time = this.timeList[0]
        this.options = abb
        this.ss()
        // console.log(this.options[0])
      }
    })
  },
  methods: {
    ss() {
      if (!this.time || !this.shop) {
        return this.$alert("请选择日期或单位", '提示')
      }
      let ling = this.$loading({
        background: 'rgba(0, 0, 0, 0.7)',
        text: '加载中...'
      })
      getScheduleDoctorList(this.shop, this.time)
          .then(res => {
            ling.close()
            if (res.GetListResult && res.GetListResult.length) {
              this.doctorList = [...res.GetListResult]
            }else {
              this.doctorList = []
            }
          })
    },
    hqyspb(id) {
      this.dialogVisible = true
      this.exid = id
      let ling = this.$loading({
        background: 'rgba(0, 0, 0, 0.7)',
        text: '加载中...'
      })
      getDoctorScheduleList(this.shop,id, this.time)
          .then(res => {
            ling.close()
            if (res.GetListResult && res.GetListResult.length > 0) {
              let arrs = res.GetListResult.map(item => {
                let str = item.ScheduleStartTime.toString()
                let js = item.ScheduleEndTime.toString()
                str = str.split('.')
                if (str.length > 1) {
                  str = str[0] + ':30'
                }else {
                  str = str[0] + ':00'
                }

                js = js.split('.')
                if (js.length > 1) {
                  js = js[0] + ':30'
                }else {
                  js = js[0] + ':00'
                }
                item.ScheduleStartTime = str
                item.ScheduleEndTime = js
                return item
              })

              this.jzList = [...arrs]
            }
          })
    },
    yy(item) {
      this.$prompt('请输入转诊内容', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        let ling = this.$loading({
          background: 'rgba(0, 0, 0, 0.7)',
          text: '添加中...'
        })
        insertOppointment(item.ScheduleCompanyId, this.shop, this.exid, item.ScheduleID, value)
        .then(res => {
          ling.close()
          this.$alert(res.displaymsg, '提示')
          .then(r => {
            this.$router.push({path: '/zzzx'})
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消预约'
        });
      });
    },
    tebsj(idx) {
      this.rqidx = idx
      this.time = this.timeList[idx]
      this.ss()
    }
  }
}
</script>

<style scoped lang="scss">
.topkkk {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  div {
    display: flex;
    align-items: center;
  }
  .xza {width: 200px;}
  p {padding-right: 8px;}
}
.content-nr {
  height: calc(100vh - 300px);
  overflow-y: auto;
  text-align: left;
  padding:0 10px;
}
.ysxx {
  width: 130px;
  display: inline-block;
  padding: 15px;
  cursor: pointer;
  border: 1px solid #d5d5d5;
  margin: 10px;
  border-radius: 5px;
  text-align: center;
  background: #e3e3e3;
  h4 {padding: 10px 0;}
  img  {
    width: 100px;
    height: 100px;
    border-radius: 50%;
  }
  .zy {
    padding-bottom: 10px;
    color: #ff3939;
  }
  .dw {
    font-size: 12px;
    color: #5f5f5f;
  }
}
.phsj {
  li {
    border-bottom: 1px solid #adadad;
    font-size: 15px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    &:hover {background: #eeeeee;}
    p{
      width: 120px;
    }
  }
}
.xz {background: #cecece;}
.sjz {
  width: 100vw;
  overflow-x: auto;
  ul {
    width: 3050px;
    display: flex;
    background: #F4F4F4;
    color: #797979;
    li {
      padding: 10px 12px;
      cursor: pointer;
    }
    .xzls {
      color: #0091FF;
    }
  }
}
</style>
